import React from 'react';
import {ScrollRestoration} from 'react-router-dom';
import PageContainer from '../../ui/PageContainer';
import {UserSessionContextProvider} from '../UserSessionContext';
import {RegFormsContextProvider} from '../../../../modules/RegForms/components/RegFormsContext';

const UserRoot = () => {
  return (
    <UserSessionContextProvider>
      <RegFormsContextProvider>
        <ScrollRestoration/>
        <PageContainer/>
      </RegFormsContextProvider>
    </UserSessionContextProvider>
  );
};

export default UserRoot;
